import { FC, useState } from 'react';
import HowGet from './HowGet';
import HowUse from './HowUse';
import styled from './index.module.scss';
import gtm from '@/utils/gtm';

interface IProps {
    type?: string;
}

const FutureBenefits: FC<IProps> = ({}) => {
    const [active, setActive] = useState('get');
    const [sliderStyle, setSliderStyle] = useState({
        width: '',
        left: '',
    });

    const tabs = [
        {
            type: 'get',
            name: 'エコポイントの貯め方',
        },
        {
            type: 'use',
            name: 'エコポイントの使用方法について',
        },
    ];

    const handleChange = (e: any, type: string) => {
        setSliderStyle({
            width: `${e.target?.clientWidth || 0}px`,
            left: `${e.target?.offsetLeft || 0}px`,
        });
        setActive(type);
    };

    return (
        <div className={styled.FutureBenefits} id="teaser-EcoBenefits">
            <div className="header">
                <h6 className="title">
                    2024年、エコポイントプログラムがさらに
                    <br />
                    バージョンアップ！最高の特典をお届けします
                </h6>
                <p className="subtitle">
                    エコポイントプログラムは、会員の皆様に最大限お楽しみいただける特典と信頼できるサービスを提供し、これからもポータブルでクリーンな、信頼できる電力を通じて人々とコミュニティを強化していきます。
                </p>
            </div>
            <div className="tabs">
                {tabs.map((item) => (
                    <span
                        key={item.type}
                        data-name={item.type}
                        className={`tab_item ${active === item.type && 'active'}`}
                        onClick={(e) => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'tab_click',
                                button_name: item.name,
                                list_name: 'none',
                            });
                            handleChange(e, item.type);
                        }}
                    >
                        {item.name}
                    </span>
                ))}
                <span className="slider" style={sliderStyle}></span>
            </div>
            <div className="tabs-content">{active === 'get' && '特定のキャンペーンで開催中のイベントに参加すると、最大4,000ポイントがもらえます。'}</div>
            {active === 'get' && <HowGet />}
            {active === 'use' && <HowUse />}
        </div>
    );
};

export default FutureBenefits;
